import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChamadoEmpresaInserirComponent } from './chamado-empresa-inserir.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: ChamadoEmpresaInserirComponent}
  ])],
  exports: [RouterModule]
})
export class ChamadoEmpresaInserirRoutingModule { }
